import CustomerProfile from '..';
import { useRouter } from '@uhg-abyss/web/hooks/useRouter';
import AddProfile from '../AddProfile';

const CopyProfile = () => {
  const router = useRouter();

  return (
   <AddProfile/>
  )
}

export default CopyProfile